module.exports = __webpack_public_path__ + "media/application/images/icons/arrow-up_white-416217f64313c3a75465856462da696c.svg";